import * as types from './mutation-type';
const mutations = {
	[types.CHANGE_UPDATE_STATE](state, payload) {
		state.isUpdated = payload;
	},
	[types.CHANGE_BLACK_TYPE](state, payload) {
		state.blackState = payload;
	},
	// --------宿舍管理------------------
	[types.SWITCH_IS_CHANGED](state, payload) {
		state.isChanged = payload;
	},
	[types.SWITCH_IS_FROM_ROOM](state, payload) {
		state.isFromRoom = payload;
	},
	[types.SWITCH_IS_FROM_DORM](state, payload) {
		state.isFromDorm = payload;
	},
	[types.SET_SELECT_DATA](state, payload) {
		state.selectData = payload;
	}
};
export default mutations;
